import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b06c93dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container my-4 my-sm-5 flex-centered flex-column"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h1 mb-3 text-center text-sm-start text-dark" }, "Thank you for getting in touch.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3 h5 fw-normal text-center text-sm-start text-dark" }, "Your enquiry has been submitted. Our team will get back to you shortly.", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-4 mb-sm-5 text-uppercase text-center text-dark" }, "Please enter your enquiry and our team will get back to you shortly.", -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-xs-12 col-md-6 my-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-message" }, "Name is required.", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "col-xs-12 col-md-6 my-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-message" }, "Surname is required.", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "col-xs-12 col-md-6 my-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-message" }, "Valid email is required.", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "col-xs-12 col-md-6 my-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-message" }, "Valid phone number is required.", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "col-xs-12 col-md-6 my-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Region", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "col-xs-12 my-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-message" }, "Message is required.", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.formSubmission && _ctx.v$)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("form", {
            id: "ContactCustomerService",
            onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)), ["prevent"])),
            action: "#"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.firstName) = $event)),
                  placeholder: "Name *",
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.firstName.$touch())),
                  name: "firstName"
                }, null, 544), [
                  [_vModelText, _ctx.formData.firstName]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.firstName.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, _hoisted_10))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.lastName) = $event)),
                  placeholder: "Surname *",
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.lastName.$touch())),
                  name: "lastName"
                }, null, 544), [
                  [_vModelText, _ctx.formData.lastName]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.lastName.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, _hoisted_13))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "email",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.email) = $event)),
                  placeholder: "E-mail Address *",
                  onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.email.$touch())),
                  name: "email"
                }, null, 544), [
                  [_vModelText, _ctx.formData.email]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, _hoisted_16))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "tel",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.phoneNumber) = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.phoneNumber.$touch())),
                  onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.phoneNumber.$touch())),
                  name: "phoneNumber",
                  placeholder: "Phone Number",
                  autocomplete: "tel"
                }, null, 544), [
                  [_vModelText, _ctx.formData.phoneNumber]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.phoneNumber.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, _hoisted_19))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.region) = $event)),
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.region.$touch())),
                  onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.region.$touch())),
                  placeholder: "Region",
                  name: "region"
                }, [
                  _hoisted_21,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionOptions, (region, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: `region-${index}`,
                      value: region.value
                    }, _toDisplayString(region.label), 9, _hoisted_22))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.formData.region]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  type: "textarea",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.message) = $event)),
                  onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.message.$touch())),
                  name: "message",
                  placeholder: "Message *"
                }, null, 544), [
                  [_vModelText, _ctx.formData.message]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.message.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, _hoisted_25))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary-residential px-4 px-lg-5 py-2 py-lg-3 mt-4",
                  disabled: _ctx.v$.$invalid || _ctx.isSubmitting
                }, "Send Message", 8, _hoisted_27)
              ])
            ])
          ], 32)
        ]))
  ]))
}